var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tailwind Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9479 10.2835C17.9479 14.5251 14.5094 17.9635 10.2679 17.9635C6.02634 17.9635 2.58789 14.5251 2.58789 10.2835C2.58789 6.04197 6.02634 2.60352 10.2679 2.60352C14.5094 2.60352 17.9479 6.04197 17.9479 10.2835ZM11.2279 14.1235C11.2279 14.6537 10.7981 15.0835 10.2679 15.0835C9.7377 15.0835 9.30789 14.6537 9.30789 14.1235C9.30789 13.5933 9.7377 13.1635 10.2679 13.1635C10.7981 13.1635 11.2279 13.5933 11.2279 14.1235ZM10.2679 5.48352C9.7377 5.48352 9.30789 5.91332 9.30789 6.44352V10.2835C9.30789 10.8137 9.7377 11.2435 10.2679 11.2435C10.7981 11.2435 11.2279 10.8137 11.2279 10.2835V6.44352C11.2279 5.91332 10.7981 5.48352 10.2679 5.48352Z",
    fill: "#F5A524"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending-icon.09dfc55a2cf5f4737a5e145608fa042d.svg";
export { ForwardRef as ReactComponent };